/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_DescriptionInputs */

const en_editor_description = /** @type {(inputs: Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short description`)
};

const de_editor_description = /** @type {(inputs: Editor_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzbeschreibung`)
};

/**
* | output |
* | --- |
* | "Short description" |
*
* @param {Editor_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_description = /** @type {((inputs?: Editor_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_description(inputs)
	return en_editor_description(inputs)
});